/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * HourglassIcon
 */
export default class HourglassIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M5 23a1 1 0 01-.117-1.993L5 21h.999L6 18c0-2.397 1.397-4.726 3.187-6C7.397 10.726 6 8.397 6 6l-.001-3H5a1 1 0 01-.117-1.993L5 1h14a1 1 0 01.117 1.993L19 3h-1.001L18 6c0 2.397-1.397 4.726-3.187 6C16.603 13.274 18 15.603 18 18l-.001 3H19a1 1 0 01.117 1.993L19 23H5zm6.999-10C10.261 12.998 8 15.486 8 18l-.001 3h8L16 18c0-2.514-2.26-5.002-3.999-5h-.002zm4-10h-8L8 6c0 2.51 2.254 4.994 3.991 5h.01c1.688.002 3.87-2.346 3.994-4.785L16 6l-.001-3z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

